module.exports = __webpack_public_path__ + "img/IMG_4395.9094a093.jpg";